// Types
import { PaymentLandingTrackingHandlersType } from './types/payment-landing.tracking.handlers.types';
import { TrackingEventsEnum, TrackingViewEventReturnType } from '@openbank/ziniaweb-ui-core-models';
import { TrackBuilderType } from 'types/track-builder.type';

const paymentViewTrackingHandler = (): TrackingViewEventReturnType => ({
  payload: {
    pageName: 'payment',
    sectionFamily: 'customer',
    sectionCategory: 'orders',
    sectionName: 'lending',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'signAndPayment',
  },
  type: TrackingEventsEnum.VIEW,
});

const PaymentLandingTrackingHandlers = (
  track: TrackBuilderType
): PaymentLandingTrackingHandlersType => ({
  handleTrackPaymentView: () => {
    track(paymentViewTrackingHandler());
  },
});

export { PaymentLandingTrackingHandlers };
